import { render, staticRenderFns } from "./saticiodemedialog.vue?vue&type=template&id=3575c602"
import script from "./saticiodemedialog.vue?vue&type=script&lang=js"
export * from "./saticiodemedialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports